import { wrapper } from "../../redux";
import Detail from "/components/pages/articles/detail";
import Redis from "/lib/redis";
import LayoutWrapper from "../../components/layouts/layoutWrapper";
import newsDetailWrapper from "../../utils/newsDetailWrapper";

export default function ObzoryNaTovaryDetailPage({
  scripts,
  host,
  news,
  isFarkop,
}) {
  return (
    <LayoutWrapper scripts={scripts} host={host}>
      <Detail news={news} isFarkop={isFarkop} />
    </LayoutWrapper>
  );
}

export const getServerSideProps = wrapper.getServerSideProps(function (store) {
  return async ({ params, query, req }) => {
    return newsDetailWrapper(
      Redis,
      store,
      query,
      req,
      params,
      "obzory-na-tovary",
      "Обзоры на товары",
    );
  };
});
